import z from "zod";

/**
 * RequisicaoProdutoServicoSchema
 */

export const RequisicaoProdutoServicoSchema = z.object({
  tipo: z.coerce.number(),
  idProdutoServico: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  idSubconta: z.coerce.number().nullable().default(null),
  quantidade: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
});

/**
 * RequisicaoProdutoServicoForm
 */

export type RequisicaoProdutoServicoForm = z.infer<typeof RequisicaoProdutoServicoSchema>;